type Color = readonly [number, number, number];

export function generatePalettes() {
  if (variableExists("--msem-color-primary")) {
    generatePalette("--msem-color-primary");
    generatePalette("--msem-color-secondary");
    return;
  }
  requestAnimationFrame(() => generatePalettes());
}

function generatePalette(variable: string) {
  const exists = paletteExists(variable);
  if (exists) return;

  const color = parseColor(`var(${variable})`);
  if (!color) return;

  const rootStyle = document.documentElement.style;
  const hsl = RGBToHSL(color);
  if (variable !== "--msem-color-medium") {
    rootStyle.setProperty(`${variable}-light`, HSLColorAddToLightness(hsl, 15));
    rootStyle.setProperty(`${variable}-lighter`, HSLColorAddToLightness(hsl, 30));
    rootStyle.setProperty(`${variable}-dark`, HSLColorAddToLightness(hsl, -10));
    rootStyle.setProperty(`${variable}-darker`, HSLColorAddToLightness(hsl, -20));
    const gradientToDark = hsl[2] >= 45;
    rootStyle.setProperty(`${variable}-gradient`, generateGradient(variable, gradientToDark));
  }
}

function paletteExists(variable: string) {
  return variableExists(`${variable}-light`);
}

function variableExists(variable: string) {
  const root = document.documentElement;
  const cs = getComputedStyle(root);
  const light = cs.getPropertyValue(variable);
  return light.length > 0;
}

function HSLColorAddToLightness(hsl: Color, lightnessDelta: number) {
  return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2] + lightnessDelta}%)`;
}

function generateGradient(variable: string, gradientToDark: boolean) {
  const to = gradientToDark ? "dark" : "light";
  return `linear-gradient(135deg, var(${variable}), var(${variable}-${to}))`;
}

function parseColor(color: string) {
  const d = document.createElement("div");
  d.style.color = color;
  document.body.appendChild(d);
  const c = getComputedStyle(d).color;
  document.body.removeChild(d);
  const m = c.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
  if (m) {
    return [Number(m[1]), Number(m[2]), Number(m[3])] as Color;
  }
}

function RGBToHSL(rgb: Color) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const l = Math.max(r, g, b);
  const s = l - Math.min(r, g, b);
  const h = s ? (l === r ? (g - b) / s : l === g ? 2 + (b - r) / s : 4 + (r - g) / s) : 0;
  return [
    60 * h < 0 ? 60 * h + 360 : 60 * h,
    100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
    (100 * (2 * l - s)) / 2,
  ] as Color;
}
